import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isFetching: false,
  isSucess: false,
  success: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.IMAGE_DESCRIPTION_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSucess: false,
      };
    case actionConstants.IMAGE_DESCRIPTION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        success: action.message, // key not send from backend
        isSuccess: true,
      };
    case actionConstants.IMAGE_DESCRIPTION_FAILURE:
      return {
        ...state,
        error: action.message,
        isFetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        isSuccess: false,
        error: '',
      };
    default:
      return state;
  }
};
